import React, { useContext, useState } from "react";
import NuevoMarca from "./NuevoMarca";
import ListadoMarcas from "./ListadoMarcas";
import "./MarcasAdmin.css";
import { Plus } from "lucide-react";
import Permiso from "../../router/Permiso";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const MarcasAdmin = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [tab, setTab] = useState("listado");
  const [debeRecargar, setDebeRecargar] = useState(false);

  const renderTab = () => {
    switch (tab) {
      case "nuevo":
        return <NuevoMarca token={token} />;
      case "listado":
        return <ListadoMarcas token={token} debeRecargar={debeRecargar} onRecargaCompleta={() => setDebeRecargar(false)} />;
      default:
        return null;
    }
  };

  const handleOpenNewMarca = () => {
    navigate("/admin/marcas/registrar");
  };

  return (
    <div className="marcas-admin-content">
      <div className="marcas-admin-header">
        <div className="marcas-admin-header-row">
          <div>
            <div className="marcas-admin-title">Marcas</div>
            <div className="marcas-admin-subtitle">Gestión de marcas</div>
          </div>
          <div className="marcas-admin-actions">
            <Permiso permiso="add_marcas">
              <button onClick={handleOpenNewMarca} className="btn-nuevo">
                <Plus size={18} style={{ marginRight: "6px" }} /> Nueva Marca
              </button>
            </Permiso>
          </div>
        </div>
        <div className="marcas-admin-tabs">
          <Permiso permiso="list_marcas">
            <button className={tab === "listado" ? "active" : ""} onClick={() => setTab("listado")}>
              Listado de Marcas
            </button>
          </Permiso>
        </div>
      </div>
      <div className="marcas-admin-tab-content">{renderTab()}</div>
    </div>
  );
};

export default MarcasAdmin;
